/* index.tsx generated by @compiled/babel-plugin v0.36.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var shimmerKeyframes = null;
var skeletonStyles = null;
var activeShimmerStyles = null;

/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */
var Skeleton = function Skeleton(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? '100px' : _ref$borderRadius,
    color = _ref.color,
    ShimmeringEndColor = _ref.ShimmeringEndColor,
    _ref$isShimmering = _ref.isShimmering,
    isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering,
    groupName = _ref.groupName,
    testId = _ref.testId;
  var groupDataAttribute = groupName && "data-".concat(groupName);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": testId
  }, groupDataAttribute && _defineProperty({}, groupDataAttribute, 'true'), {
    className: ax(["_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g", isShimmering && "", isShimmering && "_j7hq586c"]),
    style: _objectSpread(_objectSpread({}, {
      width: width,
      height: height,
      borderRadius: borderRadius,
      backgroundColor: color,
      // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
      '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
      '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
    }), {}, {
      "--_wenvhl": ix("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
      "--_1soe2er": ix("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
    })
  }));
};
export default Skeleton;